import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Loading from "../components/Loading";
import {
  TextField,
  Divider,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";

import { Container, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { clear } from "../services/actions";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";
import axios from "axios";
import { test_ip } from "../services/constants";
import { Dashen_Constants } from "../services/dashen_bank_constants";
const appSecret = Dashen_Constants.appSecret;

function Payment() {
  const data = useLocation().state;
  const [self_total_price, setSelfPrice] = useState("");
  const [laundryOption, setLaundryOption] = useState("normal");
  const [isLaundry, setIsLaundry] = useState(false);
  const [price, setPrice] = useState(data.order.total_cart_price);
  const [totalLuandrayPrice, setTotalLaundryPrice] = useState(data.order.total);
  const [self, setSelf] = useState(false);
  const [asap, setAsap] = useState(true);
  const [loading, setLoading] = useState(false);
  const [schedule, setSechdule] = useState(false);

  var user = JSON.parse(localStorage.getItem("user"));
  var cart = localStorage.getItem("cart");
  var order_payment = JSON.parse(localStorage.getItem("order_payment"));
  var store_id = localStorage.getItem("store_id");
  const unique_id = order_payment.unique_id;
  var cart_id = localStorage.getItem("cart_id");

  // const [paid, setPaid] = useState(false);
  // const [ptype, setPtype] = useState("Cash 1");

  // const scheduleStart = useRef();
  // const dispach = useDispatch();

  // var is_laundary = localStorage.getItem("is_laundary");
  // console.log(typeof is_laundary);
  // console.log(is_laundary);

  // console.log(store_id);
  // console.log("user with token>>>>>>>>>>>>");
  // console.log(user.server_token);
  // console.log(user.cart_id);
  // console.log(user.user_id);
  // console.log("uniqueid>>>>>>>>");
  // console.log(typeof order_payment.total_item_count);
  // console.log(order_payment.total_item_count);
  // console.log(JSON.stringify(order_payment, null, 2)); // Pretty-print the object
  // Define the callback handler globally
  useEffect(() => {
    window.callback_handler = function (responseData) {
      alert(`Payment callback: ${responseData}`);
      const response = JSON.parse(responseData);
      if (response.status && response.transactionStatus === "PAID") {
        // Prepare the request data for the first API call
        const reqData = {
          title: response.amount.title, // Replace with actual data fields from response
          amount: response.amount.total_amount, // Adjust based on response object structure
          trace_no: response.amount.merch_order_id,
          appId: response.amount.appid,
          message: response.message,
          issued_to: response.phoneNumber,
          status: response.status,
          transactionStatus: response.transactionStatus,
          created_date: new Date().toISOString(), // Capture the current date and time in ISO format
        };

        // Call the first API to process the payment
        axios
          .post(`${test_ip}admin/pay_payment_dashen_superapp`, reqData)
          .then((res) => {
            console.log("Order created successfully:", res.data);

            // Check if the first API call was successful
            if (res.data.success) {
              // Retrieve user data from localStorage
              // const cart = JSON.parse(localStorage.getItem('cart')); // Assume the cart is also stored in localStorage
              if (user) {
                // Prepare the request data for the second API call
                const createOrderData = {
                  user_id: user.user_id, // user ID from localStorage
                  cart_id: cart_id, // cart ID from localStorage
                  is_schedule_order:
                    cart.isSchedule != null ? cart.isSchedule : false,
                  schedule_order_start_at:
                    cart.scheduleStart != null &&
                    cart.isSchedule != null &&
                    cart.isSchedule
                      ? cart.scheduleStart?.toISOString() // Convert scheduleStart to ISO string
                      : "",
                  server_token: user.server_token, // Server token from localStorage
                };

                // Call the second API to create the order
                axios
                  .post(`${test_ip}api/user/create_order`, createOrderData)
                  .then((orderRes) => {
                    console.log(
                      "User order created successfully:",
                      orderRes.data
                    );
                  })
                  .catch((error) => {
                    console.error("Error creating user order:", error);
                  });
              } else {
                console.error(
                  "User or cart data is missing from localStorage."
                );
              }
            }
          })
          .catch((error) => {
            console.error("Error processing payment:", error);
          });
      } else {
        console.error("Payment failed:", response.message);
      }
    };
    const laundryStatus = localStorage.getItem("is_laundary") === "true"; // Assuming stored as a string
    setIsLaundry(laundryStatus);
  }, []);
  // useEffect(() => {
  //   console.log(
  //     "Price should update now:",
  //     self ? self_total_price : data.order.total_delivery_price
  //   );
  // }, [self, self_total_price, data.order.total_delivery_price]);

  // Cleanup to avoid memory leaks if needed

  // function AddLibrary(urlOfTheLibrary) {
  //   const script = document.createElement("script");
  //   script.src = urlOfTheLibrary;
  //   script.async = true;
  //   document.body.appendChild(script);
  // }
  // const handleChange = (event) => {
  //   setPtype(event.target.value);
  // };
  // const handleScehdule = (event) => {
  //   // console.log();
  //   if (event.target.checked) {
  //     setSechdule(event.target.checked);
  //     setAsap(!event.target.checked);
  //     setSelf(!event.target.checked);
  //   }
  // };
  const handleAsap = (event) => {
    if (event.target.checked) {
      setSechdule(!event.target.checked);
      setAsap(event.target.checked);
      setSelf(!event.target.checked);
    }
  };

  // 2. Create a handler for the laundry option selection
  const handleLaundryOptionChange = async (event) => {
    console.log(event.target.value);
    const selectedOption = event.target.value;
    console.log(selectedOption);
    console.log(typeof selectedOption);

    if (selectedOption) {
      setLaundryOption(selectedOption);
    }
    const payload = {
      user_id: user.user_id,
      store_id: store_id,
      total_time: 5384.190714285718,
      total_distance: 11306.800500000008,
      order_type: 7,
      is_user_pick_up_order: false,
      total_item_count: order_payment.total_item_count,
      is_user_drop_order: true,
      express_option: selectedOption,
      server_token: user.server_token,
      vehicle_id: "5b406c5dd2ddf8062d11b78a",
      tip: 0,
    };
    try {
      const response = await axios.post(
        `${test_ip}api/user/get_order_cart_invoice`,
        payload
      );
      setPrice(response.data.order_payment.total_order_price);
      setTotalLaundryPrice(response.data.order_payment.total);
      console.log(response.data.order_payment.total_order_price);
      console.log(response.data.order_payment.total); // Handle the response data
    } catch (error) {
      console.error("Error making the request:", error);
    }
  };
  const handleSelf = async (event) => {
    if (event.target.checked) {
      console.log(event.target.checked);
      setAsap(!event.target.checked);
      setSelf(event.target.checked);
    }
    const payload = {
      user_id: user.user_id,
      store_id: store_id,
      total_time: 0,
      total_distance: 0,
      order_type: 7,
      is_user_pick_up_order: true,
      total_item_count: order_payment.total_item_count,
      is_user_drop_order: true,
      express_option: "normal",
      server_token: user.server_token,
      vehicle_id: "",
      tip: 0,
    };
    try {
      const response = await axios.post(
        `${test_ip}api/user/get_order_cart_invoice`,
        payload
      );
      setSelfPrice(response.data.order_payment.total_order_price);
      console.log(
        "Response from the server:",
        response.data.order_payment.total_order_price
      );
    } catch (error) {
      console.error("Error while making the request:", error);
    }
  };

  const pay2 = () => {
    console.log(data);
    const req = {
      title: "Zmall Order",
      amount: data.order.total + "", // Ensure the amount is a string
      billRefNo: String(unique_id), // Replace with actual reference
    };

    axios
      .post(`${test_ip}admin/dashen_super_app_test`, req, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const response = res.data; // Accessing the actual data from response
        console.log("Response from server:", response);

        if (response.success) {
          // Initiate payment in super app
          const sa_request_payload = JSON.stringify({
            functionName: "initiatePayment",
            params: {
              orderPayload: response.orderPayload,
              authPayload: {
                xAPiKey: appSecret,
                xAccessToken: user.token,
              },
              callbackName: "callback_handler", // Define your callback handler
            },
          });

          // Check if Dashen Bank super app is available
          if (window.dashenbanksuperapp) {
            window.dashenbanksuperapp.send(sa_request_payload);
          } else {
            console.log("Dashen Bank Super App not found.");
          }
        } else {
          console.error("Payment order creation failed:", response.message);
        }
      })
      .catch((error) => {
        console.error("Error during payment order creation:", error);
      });
  };
  return (
    <Container>
      <ThemeProvider theme={theme}>
        <Grid
          container
          spacing={0}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid
            item
            key={122}
            xs={12}
            md={6}
            lg={3}
            style={{ paddingTop: "5px" }}
          >
            <Card key={"124"}>
              <CardContent>
                <Typography
                  variant="h5"
                  component="div"
                  style={{ fontSize: "1.2rem", textAlign: "center" }}
                >
                  Delivery details
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  Name: {user.first_name}
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  Phone: {user.phone}
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  Delivery Address: Current
                </Typography>
                {/* <Typography gutterBottom variant="h5" component="div"  style={{ fontSize: '0.8rem' }}>
                Delivery Price:{data.order.total_delivery_price}
              </Typography> */}
              </CardContent>
              <CardContent>
                <Typography
                  variant="h5"
                  component="div"
                  style={{ fontSize: "1.2rem", textAlign: "center" }}
                >
                  Delivery Option
                </Typography>
                <FormGroup>
                  {!isLaundry && (
                    <FormControlLabel
                      color="neutral"
                      control={
                        <Checkbox
                          checked={asap}
                          size="small"
                          style={{ fontSize: "0.8rem", padding: "5px" }}
                          color="neutral"
                          onChange={handleAsap}
                        />
                      }
                      label={
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="div"
                          style={{ fontSize: "0.8rem" }}
                        >
                          As soon as Possible
                        </Typography>
                      }
                      style={{ fontSize: "1.2rem" }}
                    />
                  )}
                  {/* <FormControlLabel
                    color="neutral"
                    control={
                      <Checkbox
                        checked={asap}
                        size="small"
                        style={{ fontSize: "0.8rem", padding: "5px" }}
                        color="neutral"
                        onChange={handleAsap}
                      />
                    }
                    label={
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        style={{ fontSize: "0.8rem" }}
                      >
                        As soon as Possible
                      </Typography>
                    }
                    style={{ fontSize: "1.2rem" }}
                  /> */}
                  {/* <FormControlLabel
                    color="neutral"
                    control={
                      <Checkbox
                        checked={schedule}
                        size="small"
                        color="neutral"
                        onChange={handleScehdule}
                        style={{ fontSize: "0.8rem", padding: "5px" }}
                      />
                    }
                    label={
                      <Typography style={{ fontSize: "0.8rem" }}>
                        Schedule Order
                      </Typography>
                    }
                  /> */}
                  {/* {schedule ? (
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <TextField
                        id="outlined-basic"
                        color="neutral"
                        label="Schedule Order"
                        variant="outlined"
                        ref={scheduleStart}
                      />
                    </Typography>
                  ) : null} */}
                  {!isLaundry && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="neutral"
                            size="small"
                            checked={self}
                            onChange={handleSelf}
                            style={{ fontSize: "0.8rem", padding: "5px" }}
                          />
                        }
                        label={
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            style={{ fontSize: "0.8rem" }}
                          >
                            Self Pick
                          </Typography>
                        }
                      />
                    </>
                  )}
                </FormGroup>
                {isLaundry && (
                  <>
                    {/* <Typography
                      variant="h5"
                      component="div"
                      style={{
                        fontSize: "1.2rem",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      Laundry Option
                    </Typography> */}
                    <FormControl
                      fullWidth
                      size="small"
                      style={{ marginTop: "5px" }}
                    >
                      <InputLabel>Laundry Option</InputLabel>
                      <Select
                        value={laundryOption}
                        onChange={handleLaundryOptionChange}
                        label="Laundry Option"
                      >
                        <MenuItem value="normal">Normal Delivery</MenuItem>
                        <MenuItem value="half_express">
                          Half Express Delivery
                        </MenuItem>
                        <MenuItem value="next_day">Next Day Delivery</MenuItem>
                        <MenuItem value="three_hour">
                          Three Hours Delivery
                        </MenuItem>
                      </Select>
                    </FormControl>

                    {/* Display description based on selected option */}
                    {laundryOption === "normal" && (
                      <Typography
                        variant="body2"
                        style={{ marginTop: "5px", marginLeft: "5px" }}
                      >
                        Delivered in 4-5 days
                      </Typography>
                    )}
                    {laundryOption === "half_express" && (
                      <Typography variant="body2" style={{ marginTop: "5px" }}>
                        Delivered in 2-3 days
                      </Typography>
                    )}
                    {laundryOption === "next_day" && (
                      <Typography variant="body2" style={{ marginTop: "5px" }}>
                        Delivered next day
                      </Typography>
                    )}
                    {laundryOption === "three_hours" && (
                      <Typography variant="body2" style={{ marginTop: "5px" }}>
                        Delivered in 3 hours
                      </Typography>
                    )}
                  </>
                )}
              </CardContent>
              <CardContent>
                <Typography
                  variant="h5"
                  component="div"
                  style={{ fontSize: "1.2rem", textAlign: "center" }}
                >
                  Order Data
                </Typography>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    Total Order Price
                  </Typography>

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {isLaundry
                      ? `${price} Birr`
                      : `${data.order.total_cart_price} Birr`}
                  </Typography>
                </div>

                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    Total Distance:
                  </Typography>

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {self ? 0 : data.order.total_distance.toFixed(2)} KM
                  </Typography>
                </div> */}

                {/* <Typography gutterBottom variant="h5" component="div" style={{ fontSize: '0.7rem' }}>
                Order: {data.order.unique_id}
              </Typography> */}
                {/* <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  Total Order Price:{" "}
                  {isLaundry
                    ? `${price} Birr`
                    : `${data.order.total_cart_price} Birr`}
                  {/* Price: {data.order.total_cart_price} Birr */}
                {/* </Typography> */}
                {/* <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  Toatal Distance:
                  {self ? 0 : data.order.total_distance.toFixed(2)} KM
                  {/* Toatal Distance:{data.order.total_distance} KM */}
                {/* </Typography>  */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    Service Price
                  </Typography>

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {self ? 0 : data.order.total_delivery_price} Birr
                  </Typography>
                </div>
                {/* <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "0.8rem" }}
                >
                  {/* Total: {self ? self_total_price : data.order.total} Birr */}
                {/* Service Price:{self ? 0 : data.order.total_delivery_price} Birr */}
                {/* Delivery Price:{data.order.total_delivery_price} Birr */}
                {/* </Typography>  */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    Total
                  </Typography>

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {isLaundry
                      ? totalLuandrayPrice // Assuming you have a variable holding the laundry price
                      : self
                      ? self_total_price
                      : data.order.total}{" "}
                    Bir
                  </Typography>
                </div>
                {/* <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontSize: "1.2rem" }}
                >
                  Total :{" "}
                  {isLaundry
                    ? totalLuandrayPrice // Assuming you have a variable holding the laundry price
                    : self
                    ? self_total_price
                    : data.order.total}{" "}
                  Bir
                  {/* Total: {self ? self_total_price : data.order.total} Birr */}
                {/* Total:{data.order.total} Birr */}
                {/* </Typography> */}
              </CardContent>
            </Card>
            <br />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                size="small"
                color="neutral"
                variant="contained"
                onClick={() => {
                  pay2();
                }}
              >
                Pay With Dashen
              </Button>
            </div>
          </Grid>
        </Grid>
      </ThemeProvider>
    </Container>
  );
}
export default Payment;
